import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, UrlTree } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { Observable } from 'rxjs';

import { AppSettingsService } from '~/core/services/appsettings.service';
import { AppSettings } from '~/core/models/appsettings';
import { AppConfigService } from '~/core/services/appconfig.service';

@Injectable({ providedIn: 'root' })
export class LocalAwareMsalGuard implements CanActivate {
    constructor(
        private appConfig: AppConfigService,
        private msalGuard: MsalGuard,
        private router: Router,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.appConfig.getConfig('authMode') === 'local'
            ? this.router.parseUrl('/')
            : this.msalGuard.canActivate(route, state);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private router: Router,
        private appSettingsService: AppSettingsService,
        private appConfig: AppConfigService,
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.appSettingsService.getSettings().then(async (appSettings: AppSettings) => {
            if (this.appConfig.getConfig('authMode') === 'local') {
                appSettings.user = { username: 'local-developer', name: 'Local developer' };
                appSettings.roles = [];
                await this.appSettingsService.saveSettings(appSettings);
                return true;
            }
            if (!appSettings.user) {
                if (!sessionStorage.getItem("_redirect")) {
                    sessionStorage.setItem("_redirect", state.url);
                }

                await this.router.navigate(["/auth"]);
                return false;
            } else {
                let access: boolean = false;
                let config: any = route.routeConfig;

                if (config?.roles?.length > 0) {
                    let results = config.roles.filter((role: any) => appSettings.roles.some((user: any) => role.includes(user)));

                    if (results.length > 0) {
                        access = true;
                    }
                } else {
                    access = true;
                }

                if (!access) {
                    await this.router.navigate(["/access"], { state: { type: "page" } });
                    return false;
                }
                return true;
            }
        });

    }
}
